export default __webpack_public_path__ + "static/media/heating.836b73cf.svg";